module.exports = __webpack_public_path__ + "img/a8_02.82d8dffe.jpg";